// src/components/pages/risk/partials/VaRUtils.js

/**
 * 신뢰구간별 z값 계산
 */
export function getZValue(conf) {
  if (conf === 0.99) return 2.326;
  if (conf === 0.98) return 2.054;
  if (conf === 0.97) return 1.881;
  if (conf === 0.96) return 1.751;
  if (conf === 0.95) return 1.645;
  if (conf === 0.94) return 1.555;
  if (conf === 0.93) return 1.476;
  if (conf === 0.92) return 1.405;
  if (conf === 0.91) return 1.341;
  if (conf === 0.90) return 1.282;
  return 1.645; // 기본값
}

/**
 * 통화 기호 반환
 */
export function getCurrencySymbol(currency) {
  if (currency === "USD") return "$";
  if (currency === "EUR") return "€";
  return "원";
}

/**
 * URL 쿼리 파라미터 또는 LocalStorage에서 초기 상태 로드
 */
export const getInitialStateFromURL = (locationSearch) => {
  const params = new URLSearchParams(locationSearch);
  
  const urlTickers = params.get('tickers');
  const urlWeightsString = params.get('weights');
  const urlInvestment = params.get('investment');
  const urlPeriod = params.get('period');
  const urlConfidence = params.get('confidence');
  const urlCurrency = params.get('currency');

  let initialRows = [];
  let isReady = false;

  // 1. URL 파라미터에서 로드
  if (urlTickers && urlWeightsString) {
    try {
      const tickersArray = urlTickers.split(',');
      const weightsArray = urlWeightsString.split(',').map(w => parseFloat(w) * 100);
      
      if (tickersArray.length > 0 && tickersArray.length === weightsArray.length) {
        let totalWeight = 0;
        initialRows = tickersArray.map((ticker, index) => {
          const weight = weightsArray[index] > 0 ? weightsArray[index] : 0;
          totalWeight += weight;
          return {
            ticker: ticker.toUpperCase(),
            weight: weight.toFixed(2),
          };
        });
        if (Math.abs(totalWeight - 100) < 0.1) {
            isReady = true; 
        }
      }
    } catch (e) {
      console.error("Failed to parse URL state:", e);
    }
  }

  // 2. URL 파라미터가 없으면 LocalStorage에서 로드
  if (initialRows.length === 0) {
    const storedTickers = JSON.parse(localStorage.getItem("myStocks")) || [];
    const storedWeights = JSON.parse(localStorage.getItem("optimizedPortfolioWeights")) || {};
    if (storedTickers.length > 0 && Object.keys(storedWeights).length > 0) {
      initialRows = storedTickers.map(ticker => {
        let weightValue = parseFloat(storedWeights[ticker] || 0);
        if (weightValue < 0) {
          weightValue = 0;
        }
        return {
          ticker,
          weight: weightValue,
        };
      });
    }
  }
  
  // 3. 최종 초기 상태 반환
  return {
    rows: initialRows.length > 0
      ? initialRows
      : [{ ticker: "", weight: "" }],
    totalInvestmentInput: urlInvestment ? urlInvestment : "10000",
    period: urlPeriod ? Number(urlPeriod) : 10,
    confidence: urlConfidence ? parseFloat(urlConfidence) : 0.95,
    currency: urlCurrency ? urlCurrency : "USD",
    isReady: isReady
  };
};

/**
 * 히스토그램 데이터 생성
 */
export const getHistogramData = (data, binCount) => {
  if (!data || data.length === 0) return { labels: [], counts: [], min: 0, binWidth: 0 };
  const min = Math.min(...data);
  const max = Math.max(...data);
  const binWidth = (max - min) / binCount;
  const counts = Array(binCount).fill(0);
  const labels = [];
  
  data.forEach(value => {
    let bin = Math.floor((value - min) / binWidth);
    if (bin >= binCount) bin = binCount - 1;
    counts[bin]++;
  });

  for (let i = 0; i < binCount; i++) {
    labels.push((min + i * binWidth).toFixed(4));
  }
  
  return { labels, counts, min, binWidth };
};